// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var AvatarSrcUrl = require("../../../../utils/AvatarSrcUrl.bs.js");
var Avatar__Jsx3 = require("../Avatar/Avatar__Jsx3.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function wrapSelf(v) {
  return v;
}

function AgentInfo__Jsx3(props) {
  var children = props.children;
  var __wrapAvatar = props.wrapAvatar;
  var __wrapName = props.wrapName;
  var brokerage = props.brokerage;
  var name = props.name;
  var __size = props.size;
  var onClick = props.onClick;
  var size = __size !== undefined ? __size : "small";
  var wrapName = __wrapName !== undefined ? __wrapName : wrapSelf;
  var wrapAvatar = __wrapAvatar !== undefined ? __wrapAvatar : wrapSelf;
  var avatarSrc = Core__Option.getOr(props.avatar, AvatarSrcUrl.placeholder);
  return JsxRuntime.jsxs("div", {
              children: [
                wrapAvatar(JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Avatar__Jsx3.make, {
                                onClick: onClick,
                                src: avatarSrc,
                                name: name,
                                size: size === "medium" ? ({
                                      NAME: "px",
                                      VAL: 60
                                    }) : (
                                    size === "small" ? "small" : (
                                        size === "xSmall" ? "tiny" : "large"
                                      )
                                  )
                              }),
                          className: "mr-[15px] shrink-0"
                        })),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: wrapName(name),
                              className: TailwindMerge.twMerge([
                                    "font-semibold leading-[1] text-zinc-800",
                                    Core__Option.isSome(onClick) ? "cursor-pointer" : "",
                                    size === "xSmall" || size === "small" || size === "medium" ? "text-base" : "text-lg"
                                  ]),
                              onClick: onClick
                            }),
                        brokerage !== undefined ? JsxRuntime.jsx("div", {
                                children: brokerage,
                                className: "mt-2 leading-none text-sm font-normal text-zinc-500"
                              }) : null,
                        Core__Option.getOr(children, null)
                      ],
                      className: "flex flex-col"
                    })
              ],
              className: TailwindMerge.twMerge([
                    "flex",
                    Core__Option.isSome(children) ? "items-start" : "items-center"
                  ])
            });
}

var make = AgentInfo__Jsx3;

exports.wrapSelf = wrapSelf;
exports.make = make;
/* AvatarSrcUrl Not a pure module */
